import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Listas de Robôs ")
const _hoisted_2 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_3 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "float-start" }, "ROBOS")
], -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row row-cols-2 row-cols-md-6 row-cols-md-8 g-4" }
const _hoisted_8 = { class: "card mb-0 h-100" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "dropdown float-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-toggle arrow-none card-drop",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-dots-horizontal" })
], -1)
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "header-title" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "d-flex align-items-center mt-4" }
const _hoisted_19 = { class: "flex-shrink-0" }
const _hoisted_20 = { class: "font-13 text-muted my-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 ms-2" }, null, -1)
const _hoisted_22 = { class: "text-end multi-user" }
const _hoisted_23 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, [
      _hoisted_1,
      _createVNode(_component_font_awesome_icon, { icon: "robot" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      ($setup.acesso.btnInsert)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/newlista/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}`,
            class: "btn btn-sm btn-outline-secondary",
            title: "Nova Lista"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "file" })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createTextVNode(" Total Registro: " + _toDisplayString($setup.dados.totalreg), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        class: "form-control",
        placeholder: "Procurar Nome ou Descrição",
        onKeyup: _cache[0] || (_cache[0] = ($event: any) => ($setup.search($event.target.value)))
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (lista) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-sm-3 col-xl-3 mb-3",
              key: lista.id
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      ($setup.acesso.btnAlter)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/listas/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}/${lista.id}/edit`,
                            class: "btn btn-sm btn-outline-secondary",
                            title: "Alterar lista"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      ($setup.acesso.btnDelete)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "javascript:void(0)",
                            class: "btn btn-sm btn-outline-secondary",
                            title: "Ativar Lista",
                            onClick: ($event: any) => ($setup.ativar(lista.id))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "thumbs-up" })
                          ], 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      ($setup.acesso.btnDelete)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: "javascript:void(0)",
                            class: "btn btn-sm btn-outline-secondary",
                            title: "Inativar Lista",
                            onClick: ($event: any) => ($setup.inativar(lista.id))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "thumbs-down" })
                          ], 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      ($setup.acesso.btnDelete)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 3,
                            href: "javascript:void(0)",
                            class: "btn btn-sm btn-outline-secondary",
                            title: "Excluir Lista",
                            onClick: ($event: any) => ($setup.del(lista.id))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "trash-alt" })
                          ], 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("h4", _hoisted_16, _toDisplayString(lista.name), 1),
                  ($setup.acesso.btnAlter)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/lista/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}/${lista.id}/grupos`,
                        class: "text-dark text-decoration-none",
                        title: "Grupos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h1", _hoisted_17, [
                            _createVNode(_component_font_awesome_icon, { icon: "robot" })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h5", _hoisted_20, [
                        _createElementVNode("span", {
                          class: _normalizeClass(lista.status===1 ? 'badge bg-primary d-block' : 'badge bg-danger d-block')
                        }, _toDisplayString(lista.status===1 ? ' Ativo ' : 'Inativo'), 3)
                      ])
                    ]),
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", null, _toDisplayString(lista.mail.address), 1)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        ($setup.page < $setup.lastPage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}